export const ratings26 = {
    "Ohio State": 29.46,
    "Georgia": 29.09,
    "Notre Dame": 28.74,
    "Miami": 27.08,
    "Alabama": 25.76,
    "Indiana": 25.38,
    "Texas": 23.54,
    "LSU": 22.77,
    "Utah": 22.44,
    "Oregon": 20.04,
    "Texas Tech": 19.68,
    "BYU": 19.07,
    "Nebraska": 17.44,
    "Missouri": 17.43,
    "Ole Miss": 16.84,
    "UCLA": 16.83,
    "Tennessee": 16.74,
    "Northwestern": 16.72,
    "Houston": 15.82,
    "Iowa": 13.73,
    "Louisville": 13.48,
    "Mississippi State": 13.39,
    "Oklahoma State": 12.98,
    "Oklahoma": 12.96,
    "Wisconsin": 12.84,
    "Arizona": 12.55,
    "Baylor": 12.46,
    "Florida": 12.46,
    "Michigan": 12.06,
    "USC": 11.68,
    "New Mexico": 11.61,
    "Wake Forest": 11.08,
    "SMU": 10.94,
    "Boise State": 10.84,
    "Auburn": 10.09,
    "Pittsburgh": 9.89,
    "South Carolina": 9.71,
    "Texas A&M": 9.57,
    "Kentucky": 9.56,
    "James Madison": 9.07,
    "Penn State": 9.04,
    "Kansas State": 8.87,
    "TCU": 8.33,
    "Virginia Tech": 8.24,
    "Duke": 8.09,
    "North Dakota State": 8.03,
    "Memphis": 7.68,
    "Oregon State": 7.17,
    "Liberty": 7.16,
    "North Carolina": 7.04,
    "Kansas": 7.03,
    "Virginia": 6.49,
    "UCF": 5.95,
    "Florida State": 5.91,
    "Washington": 5.18,
    "Illinois": 4.82,
    "Minnesota": 4.8,
    "Clemson": 4.58,
    "Purdue": 4.49,
    "Arizona State": 3.65,
    "Fresno State": 3.58,
    "Iowa State": 3.46,
    "Cincinnati": 3.33,
    "Michigan State": 2.12,
    "Vanderbilt": 1.68,
    "Air Force": 0.89,
    "UTSA": 0.72,
    "UNLV": 0.58,
    "Georgia Tech": 0.34,
    "West Virginia": -0.87,
    "North Texas": -1,
    "Syracuse": -1.23,
    "Colorado": -1.3,
    "Navy": -1.39,
    "Arkansas": -1.4,
    "South Florida": -1.47,
    "Texas State": -1.59,
    "Florida Atlantic": -1.76,
    "Army": -2.08,
    "California": -2.14,
    "NC State": -2.47,
    "Georgia State": -2.51,
    "UConn": -2.54,
    "East Carolina": -2.96,
    "Maryland": -3.21,
    "Boston College": -3.59,
    "Western Michigan": -3.78,
    "Georgia Southern": -4.28,
    "Nevada": -4.4,
    "Toledo": -4.64,
    "Louisiana": -4.77,
    "Jacksonville State": -4.92,
    "Tulsa": -5.85,
    "Florida International": -6.13,
    "Tulane": -6.42,
    "Louisiana Tech": -6.63,
    "Rutgers": -6.77,
    "Troy": -7.61,
    "Ohio": -7.76,
    "App State": -8.37,
    "Temple": -8.52,
    "Utah State": -8.56,
    "San Diego State": -9.36,
    "Colorado State": -9.73,
    "South Alabama": -10.09,
    "Arkansas State": -10.25,
    "Old Dominion": -10.27,
    "Miami (OH)": -10.27,
    "Washington State": -10.6,
    "Massachusetts": -11.39,
    "Coastal Carolina": -11.5,
    "Kennesaw State": -11.63,
    "Hawai'i": -12.1,
    "San José State": -12.79,
    "Delaware": -12.95,
    "Buffalo": -12.96,
    "UAB": -13.44,
    "Western Kentucky": -13.53,
    "Eastern Michigan": -13.62,
    "Rice": -14.17,
    "New Mexico State": -14.73,
    "Stanford": -14.77,
    "Marshall": -14.82,
    "Wyoming": -15.08,
    "Central Michigan": -15.64,
    "Sam Houston": -16.36,
    "Bowling Green": -17.86,
    "Middle Tennessee": -18.76,
    "Missouri State": -19.48,
    "Southern Miss": -19.99,
    "Akron": -21.9,
    "Northern Illinois": -22.35,
    "Kent State": -22.38,
    "Ball State": -24.45,
    "UTEP": -24.73,
    "Sacramento State": -26.48,
    "UL Monroe": -27.65,
    "Charlotte": -28.54,

}